import { render, staticRenderFns } from "./templatePreview.vue?vue&type=template&id=6ccc52e0&scoped=true&"
import script from "./templatePreview.vue?vue&type=script&lang=js&"
export * from "./templatePreview.vue?vue&type=script&lang=js&"
import style0 from "./templatePreview.vue?vue&type=style&index=0&id=6ccc52e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc52e0",
  null
  
)

export default component.exports